import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { ConnectionService } from '@services/connection-service';
import { UserService } from '@services/user/user.service';

export const shopGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const connectionService = inject(ConnectionService);
  const userService = inject(UserService);

  const user = await connectionService.getActingUser();
  if (userService.isUnpaidUser(user)) {
    return router.createUrlTree(['/user'], { queryParams: { tab: 'home' } });
  }
  return true;
};
